import { useState } from "react";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

// Generic searchable single-select. items: [{value, label, hint}]. Optional onAdd shows an "Add …" row.
export const Combobox = ({ items, value, onChange, placeholder = "Select", addLabel, onAdd, testid, className = "", disabled = false, emptyText = "No matches." }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const selected = items.find((i) => i.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" disabled={disabled} data-testid={testid} className={`flex h-9 w-full items-center justify-between rounded-md border border-input bg-white px-3 py-2 text-sm shadow-sm disabled:opacity-60 disabled:cursor-not-allowed ${className}`}>
          <span className={`truncate ${selected ? "" : "text-slate-400"}`}>{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[260px]" align="start">
        <Command>
          <CommandInput placeholder="Type to search…" value={q} onValueChange={setQ} data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              {items.map((i) => (
                <CommandItem key={i.value} value={`${i.label} ${i.hint || ""}`} onSelect={() => { onChange(i.value); setOpen(false); }} data-testid={testid ? `${testid}-option-${i.value}` : undefined}>
                  <Check className={`mr-2 h-4 w-4 ${i.value === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{i.label}</span>{i.hint && <span className="ml-2 text-xs text-slate-400 truncate">{i.hint}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
            {onAdd && (
              <CommandGroup>
                <CommandItem value={`__add ${q}`} onSelect={() => { setOpen(false); onAdd(q); }} className="text-teal-700" data-testid={testid ? `${testid}-add` : undefined}>
                  <Plus className="mr-2 h-4 w-4" /> {addLabel || "Add"}{q ? ` "${q}"` : ""}
                </CommandItem>
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
